"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Selector = require("../../Core/Selector");
var _Translator = require("../../Core/Translator");
var _aggregates = require("../../VIMANAMetrics/Sections/aggregates");
var _utils = require("../common/MetricsFilters/utils");
var _tooltipSort = require("../common/tooltipSort");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Well = _styledComponents["default"].div.withConfig({
  displayName: "ActivitiesChartFields__Well",
  componentId: "sc-3q235p-0"
})(["padding:7px;border:2px dashed #ddd;margin-bottom:10px;"]);
var WellTitle = _styledComponents["default"].div.withConfig({
  displayName: "ActivitiesChartFields__WellTitle",
  componentId: "sc-3q235p-1"
})(["font-weight:bold;margin-bottom:10px;"]);
var AxisControls = _styledComponents["default"].div.withConfig({
  displayName: "ActivitiesChartFields__AxisControls",
  componentId: "sc-3q235p-2"
})(["display:flex;> label{margin-right:15px;}"]);
var LegendsWell = (0, _styledComponents["default"])(Well).withConfig({
  displayName: "ActivitiesChartFields__LegendsWell",
  componentId: "sc-3q235p-3"
})(["opacity:", ";label.disabled,input:disabled{cursor:not-allowed;}"], function (props) {
  return props.disabled ? 0.3 : 1;
});
function ActivitiesChartFields(props) {
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path;
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  var selectedAggregates = element.props.aggregations.filter(function (child) {
    return child.section === "aggregates";
  });
  var aggregationItems = (0, _utils.flattenAggregates)([_aggregates.byTime]);
  var CheckboxEl = function CheckboxEl(_ref) {
    var propName = _ref.propName,
      defaultLabel = _ref.defaultLabel,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
    return /*#__PURE__*/_react["default"].createElement("label", {
      className: disabled ? "disabled" : "",
      htmlFor: propName
    }, /*#__PURE__*/_react["default"].createElement("input", {
      disabled: disabled,
      id: propName,
      type: "checkbox",
      checked: element.props[propName] || false,
      onChange: function onChange(e) {
        return elementEditor.setProp(path, propName, e.target.checked);
      }
    }), " ", translate("MetricChartFields.axes." + propName + ".label", defaultLabel));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ActivitiesChartFields.tooltipSort.label", "Sort")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    "data-testid": "ActivitiesChartFields.tooltipSort",
    value: element.props.tooltipSort || _tooltipSort.TOOLTIP_SORT_DESC,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "tooltipSort", e.target.value);
    }
  }, _tooltipSort.TOOLTIP_SORT_OPTIONS.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.key,
      value: option.key
    }, translate("ActivitiesChartFields.tooltipSort." + option.key, option.label));
  })))), /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(WellTitle, null, translate("MetricChartFields.axes.xaxis.label", "X Axis")), /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    placeholder: translate("MetricChartFields.select-aggregate", "Select Aggregate"),
    getKey: function getKey(item) {
      return item.name;
    },
    renderItemText: function renderItemText(item) {
      return item.label;
    },
    items: aggregationItems,
    selected: selectedAggregates,
    style: {
      marginBottom: 10
    },
    onSelect: function onSelect(selected) {
      if (!(0, _reactFastCompare["default"])(selectedAggregates, selected)) {
        var groups = selected.reduce(function (acc, item) {
          acc[item.groupId] = item;
          return acc;
        }, {});
        var values = Object.values(groups);
        elementEditor.setProps(path, {
          aggregations: values
        });
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(AxisControls, null, /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "hideXAxis",
    defaultLabel: "Hide Axis"
  }), /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "hideXUnits",
    defaultLabel: "Hide Label"
  }))), /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(WellTitle, null, translate("MetricChartFields.axes.xaxis.label", "Y Axis")), /*#__PURE__*/_react["default"].createElement(AxisControls, null, /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "hideYAxis",
    defaultLabel: "Hide Axis"
  }), /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "hideYUnits",
    defaultLabel: "Hide Label"
  }))), /*#__PURE__*/_react["default"].createElement(LegendsWell, null, /*#__PURE__*/_react["default"].createElement(WellTitle, null, translate("MetricChartFields.showLegends", "Legend")), /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "showLegends",
    defaultLabel: "Show Legend"
  })), /*#__PURE__*/_react["default"].createElement(Well, null, /*#__PURE__*/_react["default"].createElement(WellTitle, null, translate("MetricChartFields.showTooltip", "Tooltip")), /*#__PURE__*/_react["default"].createElement(CheckboxEl, {
    propName: "showTooltip",
    defaultLabel: "Show Tooltip"
  })));
}
var _default = exports["default"] = ActivitiesChartFields;